'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { useSession } from '@/lib/auth-client';
import { useUserEntityConnections } from '@/lib/hooks/useConnections';
import { Loader2, Trash2 } from 'lucide-react';
import type { StructuredInterestConfig } from '@sizzlenz/shared';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
interface EntityOption {
  id: number;
  name: string;
}
interface StructuredInterestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  config: StructuredInterestConfig;
  onSubmit: (data: {
    entities: EntityOption[];
    note?: string;
    brand?: string;
    timeframe?: string;
  }) => void;
  onRemove?: () => void;
  isEditing?: boolean;
  initialEntities?: EntityOption[];
  initialNote?: string;
  initialBrand?: string;
  initialTimeframe?: string;
  isPending?: boolean;
  isRemovePending?: boolean;
}
export function StructuredInterestDialog(t0) {
  const $ = _c(117);
  const {
    open,
    onOpenChange,
    config,
    onSubmit,
    onRemove,
    isEditing: t1,
    initialEntities: t2,
    initialNote: t3,
    initialBrand: t4,
    initialTimeframe: t5,
    isPending: t6,
    isRemovePending: t7
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  let t8;
  if ($[0] !== t2) {
    t8 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const initialEntities = t8;
  const initialNote = t3 === undefined ? "" : t3;
  const initialBrand = t4 === undefined ? "" : t4;
  const initialTimeframe = t5 === undefined ? "" : t5;
  const isPending = t6 === undefined ? false : t6;
  const isRemovePending = t7 === undefined ? false : t7;
  const {
    data: session
  } = useSession();
  const userId = session?.user?.id ? Number(session.user.id) : undefined;
  const {
    data: connectionsData,
    isLoading: loadingEntities
  } = useUserEntityConnections(userId);
  const [selectedEntities, setSelectedEntities] = useState(initialEntities);
  const [note, setNote] = useState(initialNote);
  const [brand, setBrand] = useState(initialBrand);
  const [timeframe, setTimeframe] = useState(initialTimeframe);
  let t10;
  let t9;
  if ($[2] !== initialBrand || $[3] !== initialEntities || $[4] !== initialNote || $[5] !== initialTimeframe || $[6] !== open) {
    t9 = () => {
      if (open) {
        setSelectedEntities(initialEntities);
        setNote(initialNote);
        setBrand(initialBrand);
        setTimeframe(initialTimeframe);
      }
    };
    t10 = [open, initialEntities, initialNote, initialBrand, initialTimeframe];
    $[2] = initialBrand;
    $[3] = initialEntities;
    $[4] = initialNote;
    $[5] = initialTimeframe;
    $[6] = open;
    $[7] = t10;
    $[8] = t9;
  } else {
    t10 = $[7];
    t9 = $[8];
  }
  useEffect(t9, t10);
  let T0;
  let T1;
  let handleSubmit;
  let isValid;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[9] !== brand || $[10] !== config.allowMultipleEntities || $[11] !== config.allowNote || $[12] !== config.dialogDescription || $[13] !== config.dialogTitle || $[14] !== config.enableBrandField || $[15] !== config.enableEntitySelection || $[16] !== config.enableTimeframe || $[17] !== config.requireBrandField || $[18] !== config.requireEntity || $[19] !== config.requireNote || $[20] !== config.requireTimeframe || $[21] !== connectionsData?.pages || $[22] !== isEditing || $[23] !== loadingEntities || $[24] !== note || $[25] !== onOpenChange || $[26] !== onSubmit || $[27] !== open || $[28] !== selectedEntities || $[29] !== timeframe) {
    const userEntities = (connectionsData?.pages || []).flatMap(_temp2);
    let t18;
    if ($[41] !== config.allowMultipleEntities) {
      t18 = entity => {
        setSelectedEntities(prev => {
          const exists = prev.find(e => e.id === entity.id);
          if (exists) {
            return prev.filter(e_0 => e_0.id !== entity.id);
          }
          if (!config.allowMultipleEntities) {
            return [entity];
          }
          return [...prev, entity];
        });
      };
      $[41] = config.allowMultipleEntities;
      $[42] = t18;
    } else {
      t18 = $[42];
    }
    const handleToggleEntity = t18;
    let t19;
    if ($[43] !== brand || $[44] !== config.allowNote || $[45] !== config.enableBrandField || $[46] !== config.enableEntitySelection || $[47] !== config.enableTimeframe || $[48] !== note || $[49] !== onSubmit || $[50] !== selectedEntities || $[51] !== timeframe) {
      t19 = () => {
        onSubmit({
          entities: config.enableEntitySelection !== false ? selectedEntities : [],
          note: config.allowNote && note.trim() ? note.trim() : undefined,
          brand: config.enableBrandField && brand.trim() ? brand.trim() : undefined,
          timeframe: config.enableTimeframe && timeframe ? timeframe : undefined
        });
      };
      $[43] = brand;
      $[44] = config.allowNote;
      $[45] = config.enableBrandField;
      $[46] = config.enableEntitySelection;
      $[47] = config.enableTimeframe;
      $[48] = note;
      $[49] = onSubmit;
      $[50] = selectedEntities;
      $[51] = timeframe;
      $[52] = t19;
    } else {
      t19 = $[52];
    }
    handleSubmit = t19;
    const entityValid = config.enableEntitySelection === false || !config.requireEntity || selectedEntities.length > 0;
    let t20;
    if ($[53] !== config.requireNote || $[54] !== note) {
      t20 = !config.requireNote || note.trim().length > 0;
      $[53] = config.requireNote;
      $[54] = note;
      $[55] = t20;
    } else {
      t20 = $[55];
    }
    const noteValid = t20;
    let t21;
    if ($[56] !== brand || $[57] !== config.enableBrandField || $[58] !== config.requireBrandField) {
      t21 = !config.enableBrandField || !config.requireBrandField || brand.trim().length > 0;
      $[56] = brand;
      $[57] = config.enableBrandField;
      $[58] = config.requireBrandField;
      $[59] = t21;
    } else {
      t21 = $[59];
    }
    const brandValid = t21;
    const timeframeValid = !config.enableTimeframe || !config.requireTimeframe || !!timeframe;
    isValid = entityValid && noteValid && brandValid && timeframeValid;
    T1 = Dialog;
    t16 = open;
    t17 = onOpenChange;
    T0 = DialogContent;
    t14 = "sm:max-w-md";
    const t22 = config.dialogTitle || (isEditing ? "Edit Interest" : "Register Interest");
    if ($[60] !== t22) {
      t15 = <DialogHeader><DialogTitle>{t22}</DialogTitle></DialogHeader>;
      $[60] = t22;
      $[61] = t15;
    } else {
      t15 = $[61];
    }
    t11 = "space-y-4 py-2";
    if ($[62] !== config.dialogDescription) {
      t12 = config.dialogDescription && <p className="text-sm text-muted-foreground">{config.dialogDescription}</p>;
      $[62] = config.dialogDescription;
      $[63] = t12;
    } else {
      t12 = $[63];
    }
    t13 = config.enableEntitySelection !== false && <div className="space-y-2"><Label>{config.requireEntity ? "Select entity *" : "Select entity (optional)"}</Label><p className="text-sm text-muted-foreground">Which {config.allowMultipleEntities ? "entities do" : "entity does"} this interest apply to?</p>{loadingEntities ? <div className="flex items-center gap-2 py-4 text-sm text-gray-500"><Loader2 className="w-4 h-4 animate-spin" />Loading your entities...</div> : userEntities.length === 0 ? <p className="text-sm text-gray-500 py-2">You are not a team member of any entities yet.</p> : <div className="space-y-2 max-h-48 overflow-y-auto border rounded-md p-2">{userEntities.map(entity_0 => {
          const isSelected = selectedEntities.some(e_1 => e_1.id === entity_0.id);
          return <label key={entity_0.id} className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-50 cursor-pointer"><Checkbox checked={isSelected} onCheckedChange={() => handleToggleEntity(entity_0)} /><span className="text-sm">{entity_0.name}</span></label>;
        })}</div>}</div>;
    $[9] = brand;
    $[10] = config.allowMultipleEntities;
    $[11] = config.allowNote;
    $[12] = config.dialogDescription;
    $[13] = config.dialogTitle;
    $[14] = config.enableBrandField;
    $[15] = config.enableEntitySelection;
    $[16] = config.enableTimeframe;
    $[17] = config.requireBrandField;
    $[18] = config.requireEntity;
    $[19] = config.requireNote;
    $[20] = config.requireTimeframe;
    $[21] = connectionsData?.pages;
    $[22] = isEditing;
    $[23] = loadingEntities;
    $[24] = note;
    $[25] = onOpenChange;
    $[26] = onSubmit;
    $[27] = open;
    $[28] = selectedEntities;
    $[29] = timeframe;
    $[30] = T0;
    $[31] = T1;
    $[32] = handleSubmit;
    $[33] = isValid;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    T0 = $[30];
    T1 = $[31];
    handleSubmit = $[32];
    isValid = $[33];
    t11 = $[34];
    t12 = $[35];
    t13 = $[36];
    t14 = $[37];
    t15 = $[38];
    t16 = $[39];
    t17 = $[40];
  }
  let t18;
  if ($[64] !== config.allowNote || $[65] !== config.requireNote || $[66] !== note) {
    t18 = config.allowNote && <div className="space-y-2"><Label htmlFor="interest-note">Note {config.requireNote ? "*" : "(optional)"}</Label><Textarea id="interest-note" value={note} onChange={e_2 => setNote(e_2.target.value)} placeholder="Add any additional context about your interest..." rows={3} /></div>;
    $[64] = config.allowNote;
    $[65] = config.requireNote;
    $[66] = note;
    $[67] = t18;
  } else {
    t18 = $[67];
  }
  let t19;
  if ($[68] !== brand || $[69] !== config.brandFieldLabel || $[70] !== config.enableBrandField || $[71] !== config.requireBrandField) {
    t19 = config.enableBrandField && <div className="space-y-2"><Label htmlFor="interest-brand">{config.brandFieldLabel || "Brand / Business"}{" "}{config.requireBrandField ? "*" : "(optional)"}</Label><Input id="interest-brand" value={brand} onChange={e_3 => setBrand(e_3.target.value)} placeholder={`Enter ${(config.brandFieldLabel || "brand or business name").toLowerCase()}...`} /></div>;
    $[68] = brand;
    $[69] = config.brandFieldLabel;
    $[70] = config.enableBrandField;
    $[71] = config.requireBrandField;
    $[72] = t19;
  } else {
    t19 = $[72];
  }
  let t20;
  if ($[73] !== config.enableTimeframe || $[74] !== config.requireTimeframe || $[75] !== config.timeframeLabel || $[76] !== config.timeframeOptions || $[77] !== timeframe) {
    t20 = config.enableTimeframe && <div className="space-y-2"><Label>{config.timeframeLabel || "Timeframe"}{" "}{config.requireTimeframe ? "*" : "(optional)"}</Label><Select value={timeframe} onValueChange={setTimeframe}><SelectTrigger className="w-full"><SelectValue placeholder={`Select ${(config.timeframeLabel || "timeframe").toLowerCase()}...`} /></SelectTrigger><SelectContent>{(config.timeframeOptions || [{
            value: "right_now",
            label: "Right Now"
          }, {
            value: "next_few_days",
            label: "Next Few Days"
          }, {
            value: "next_couple_weeks",
            label: "Next Couple of Weeks"
          }, {
            value: "next_month",
            label: "Next Month"
          }]).map(_temp3)}</SelectContent></Select></div>;
    $[73] = config.enableTimeframe;
    $[74] = config.requireTimeframe;
    $[75] = config.timeframeLabel;
    $[76] = config.timeframeOptions;
    $[77] = timeframe;
    $[78] = t20;
  } else {
    t20 = $[78];
  }
  let t21;
  if ($[79] !== t11 || $[80] !== t12 || $[81] !== t13 || $[82] !== t18 || $[83] !== t19 || $[84] !== t20) {
    t21 = <div className={t11}>{t12}{t13}{t18}{t19}{t20}</div>;
    $[79] = t11;
    $[80] = t12;
    $[81] = t13;
    $[82] = t18;
    $[83] = t19;
    $[84] = t20;
    $[85] = t21;
  } else {
    t21 = $[85];
  }
  let t22;
  if ($[86] !== isEditing || $[87] !== isPending || $[88] !== isRemovePending || $[89] !== onRemove) {
    t22 = isEditing && onRemove ? <Button type="button" variant="destructive" onClick={onRemove} disabled={isRemovePending || isPending} className="cursor-pointer">{isRemovePending ? <><Loader2 className="w-4 h-4 animate-spin mr-2" />Removing...</> : <><Trash2 className="w-4 h-4 mr-2" />Remove Interest</>}</Button> : <div />;
    $[86] = isEditing;
    $[87] = isPending;
    $[88] = isRemovePending;
    $[89] = onRemove;
    $[90] = t22;
  } else {
    t22 = $[90];
  }
  let t23;
  if ($[91] !== onOpenChange) {
    t23 = <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="cursor-pointer">Cancel</Button>;
    $[91] = onOpenChange;
    $[92] = t23;
  } else {
    t23 = $[92];
  }
  const t24 = !isValid || isPending || isRemovePending;
  let t25;
  if ($[93] !== isEditing || $[94] !== isPending) {
    t25 = isPending ? <><Loader2 className="w-4 h-4 animate-spin mr-2" />Saving...</> : isEditing ? "Update Interest" : "Confirm Interest";
    $[93] = isEditing;
    $[94] = isPending;
    $[95] = t25;
  } else {
    t25 = $[95];
  }
  let t26;
  if ($[96] !== handleSubmit || $[97] !== t24 || $[98] !== t25) {
    t26 = <Button type="button" onClick={handleSubmit} disabled={t24} className="cursor-pointer">{t25}</Button>;
    $[96] = handleSubmit;
    $[97] = t24;
    $[98] = t25;
    $[99] = t26;
  } else {
    t26 = $[99];
  }
  let t27;
  if ($[100] !== t23 || $[101] !== t26) {
    t27 = <div className="flex items-center gap-2">{t23}{t26}</div>;
    $[100] = t23;
    $[101] = t26;
    $[102] = t27;
  } else {
    t27 = $[102];
  }
  let t28;
  if ($[103] !== t22 || $[104] !== t27) {
    t28 = <DialogFooter className="flex items-center justify-between sm:justify-between">{t22}{t27}</DialogFooter>;
    $[103] = t22;
    $[104] = t27;
    $[105] = t28;
  } else {
    t28 = $[105];
  }
  let t29;
  if ($[106] !== T0 || $[107] !== t14 || $[108] !== t15 || $[109] !== t21 || $[110] !== t28) {
    t29 = <T0 className={t14}>{t15}{t21}{t28}</T0>;
    $[106] = T0;
    $[107] = t14;
    $[108] = t15;
    $[109] = t21;
    $[110] = t28;
    $[111] = t29;
  } else {
    t29 = $[111];
  }
  let t30;
  if ($[112] !== T1 || $[113] !== t16 || $[114] !== t17 || $[115] !== t29) {
    t30 = <T1 open={t16} onOpenChange={t17}>{t29}</T1>;
    $[112] = T1;
    $[113] = t16;
    $[114] = t17;
    $[115] = t29;
    $[116] = t30;
  } else {
    t30 = $[116];
  }
  return t30;
}
function _temp3(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}
function _temp2(page) {
  return page.connections.map(_temp);
}
function _temp(conn) {
  return {
    id: Number(conn.toId),
    name: conn.entity?.name_1 || `Entity ${conn.toId}`
  };
}